/* eslint-env browser */
import inherit from 'component-inherit';
import Query from './query';

const ua = navigator.userAgent.toLowerCase();

/**
 * Creates an Safari instance
 */

export default function Safari() {
  if (!(this instanceof Safari)) {
    return new Safari();
  }

  this.name = 'Safari';
  this.uaname = 'safari';
  this.version = ua.indexOf('chrome') == -1 && ua.indexOf(this.uaname) != -1
    ? parseInt(ua.split(`${this.uaname}/`)[1])
    : false;
}

/**
 * Inherits Safari from Query
 */

inherit(Safari, Query);



// WEBPACK FOOTER //
// ./src/modules/npm-component/user-agent/safari.js